import { makeStyles } from '@material-ui/styles';
import { useChannelStateContext } from 'stream-chat-react';
import { Theme } from '@bizzabo/design-system';

const ThreadStart: React.FC = () => {
    const classes = useStyles();
    const { thread } = useChannelStateContext();

    return (
        <div className={classes.threadStart}>
            {!!thread.reply_count && (
                <span className={classes.text}>
                    {thread.reply_count === 1
                        ? `${thread.reply_count} Reply`
                        : `${thread.reply_count} Replies`}
                </span>
            )}
        </div>
    );
};

const useStyles = makeStyles(
    (theme: Theme) => ({
        threadStart: {
            position: 'relative',
            paddingLeft: '20px',
            '&:before': {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: 0,
                right: 0,
                height: 1,
                backgroundColor: theme.palette.neutral[400],
                transform: 'translateY(-50%)',
            },
        },
        text: {
            position: 'relative',
            padding: `0 8px`,
            fontSize: '1.2rem',
            color: theme.palette.greys[500],
            backgroundColor: theme.palette.greys[100],
            zIndex: 1,
        },
    }),
    { classNamePrefix: 'thread-start' }
);

export default ThreadStart;
